/* eslint-disable jsx-a11y/media-has-caption */
import {
  createContext,
  MutableRefObject,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react';

export interface AudioContextProps {
  audioRef: MutableRefObject<HTMLAudioElement | null> | null;
  audioContext: AudioContext | null;
}

export const RemixerAudioContext = createContext<AudioContextProps>({
  audioRef: null,
  audioContext: null,
});

const AudioProvider = ({ children }: { children: ReactNode }) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const [audioContext, setAudioContext] = useState<AudioContext | null>(null);

  useEffect(() => {
    const context = new AudioContext();
    const bodyClickHandler = () => {
      if (context.state === 'closed') {
        return;
      }
      context.resume();
    };
    document.body.addEventListener('click', bodyClickHandler, {
      once: true,
    });
    setAudioContext(context);
    return () => {
      document.body.removeEventListener('click', bodyClickHandler);
      context.close();
    };
  }, []);

  return (
    <RemixerAudioContext.Provider value={{ audioRef, audioContext }}>
      <audio ref={audioRef} />
      {children}
    </RemixerAudioContext.Provider>
  );
};

export default AudioProvider;
